var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app" }, [
    _c("div", { staticClass: "app_con" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("./assets/images/logo.png"), alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c("img", {
          staticClass: "main-image",
          attrs: { src: require("./assets/images/main.png"), alt: "" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "con_r" },
          [
            _vm.isLogin
              ? _c("Main", {
                  attrs: {
                    account: _vm.activeAccount,
                    "chain-supported": _vm.isSupportedChain,
                  },
                  on: {
                    "account-change": _vm.handleWalletConnected,
                    "switch-network": _vm.handleSwitchNetwork,
                  },
                })
              : _c("login", {
                  on: { loginSuccess: _vm.handleWalletConnected },
                }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }